// Asks where to send a gig, then opens WhatsApp or text with the right message.
//  - kind "family": public link (where and when, tickets only)
//  - kind "dep": deputy link (full working detail)
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { apiClient, API } from "@/App";
import { toast } from "sonner";
import {
  familyShareMessage,
  depShareMessage,
  createDepLink,
  openShareChannel,
  publicShareUrl,
} from "@/lib/gigShare";

export default function GigShareDialog({ gig, kind, open, onClose, onPublicEnabled }) {
  const [busy, setBusy] = useState(false);
  const isDep = kind === "dep";
  const apiBase = API.startsWith("http") ? API : window.location.origin + API;

  const send = async (platform) => {
    if (!gig?.gig_id) return;
    setBusy(true);
    try {
      if (isDep) {
        const depUrl = await createDepLink(apiClient, gig.gig_id);
        openShareChannel(platform, depShareMessage(gig, depUrl));
      } else {
        let token = gig.share_token;
        if (!gig.share_enabled || !token) {
          // Turning sharing on is part of sending the family link
          const res = await apiClient.put(`/gigs/${gig.gig_id}/share`);
          token = res.data.share_token;
          onPublicEnabled?.(token, res.data.share_enabled);
        }
        openShareChannel(platform, familyShareMessage(gig, publicShareUrl(apiBase, token)));
      }
      onClose();
    } catch {
      toast.error("Could not create the link");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent style={{ maxWidth: 360 }} data-testid={isDep ? "dep-share-dialog" : "family-share-dialog"}>
        <DialogHeader>
          <DialogTitle>{isDep ? "Dep this out" : "Share gig"}</DialogTitle>
          <DialogDescription>
            {isDep
              ? "Sends a deputy everything to play the gig: call time, dress code, fee and schedule."
              : "Sends the date, start time, venue, address and tickets. Fee, dress code and call time are not included."}
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          <Button variant="outline" disabled={busy} onClick={() => send("whatsapp")} data-testid="share-dialog-whatsapp">
            WhatsApp
          </Button>
          <Button variant="outline" disabled={busy} onClick={() => send("sms")} data-testid="share-dialog-text">
            Text
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
